<div
  [rtTooltip]="tooltipValue | translate"
  [class.active]="chartType().value === component().chartType"
  [class.disabled]="chartType().disabled"
  (click)="chartTypeSelected.emit(chartType())"
  class="preview-chart"
>
  <rt-icon [name]="iconName" [size]="'large-xx'" />
</div>
@if (chartType().disabled) {
  <div
    [rtTooltip]="'tlr.component_builder_dialog.unavailable_visualization_tooltip' | translate"
    class="chart-type-overlay"
  ></div>
}
